// Zoom tiers of the galaxy map (spec 15c §3.2). The camera scale is screen pixels per light-year;
// neighbouring systems sit ~5 ly apart (`galaxy.typical_neighbour_distance_ly`).
export type ZoomTier = 'far' | 'mid' | 'close';

/** Lowest camera scale of each tier. Client constants tuned on staging, not balance numbers. */
export const TIER_MIN_SCALE = { mid: 12, close: 28 } as const;

/** The scale Home, search and map links jump to: inside the mid tier. */
export const FOCUS_SCALE = 16;

export function zoomTier(scale: number): ZoomTier {
  if (scale >= TIER_MIN_SCALE.close) return 'close';
  if (scale >= TIER_MIN_SCALE.mid) return 'mid';
  return 'far';
}

/** A system dot's radius on screen: 0.9 ly, but never smaller or larger than these. */
export const DOT_RADIUS_PX = { min: 3, max: 9 } as const;

export function dotRadiusPx(scale: number): number {
  return Math.min(DOT_RADIUS_PX.max, Math.max(DOT_RADIUS_PX.min, 0.9 * scale));
}
